// ======================================================================
// File Name       : ReservedEmailInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { RESERVED_FLAG } from '../../constants/EmailConstants';
import { DEFAULT_DATE_FORMAT_NO_MINUTE } from '../../constants/index';
import { parseDateForDetail } from '../../utils/index';
import { Item } from '../Detail';

class ReservedEmailInfo extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <Form className='form-horizontal'>
        <Item name="件名" value={data.reservedEmailTitle} />
        <Item name="本文" value={data.reservedEmailContents} />
        <Item name="返信時の宛先" value={data.reservedEmailReplyTo} />
        {(data.reservedFlag === true || data.reservedFlag === RESERVED_FLAG.RESERVATION) && (
          <Item
            name="予約日時"
            value={parseDateForDetail(
              data.reservedDate,
              DEFAULT_DATE_FORMAT_NO_MINUTE,
            )}
          />
        )}
        <Item name="送信先ユーザー数" value={`${data.receiverUserNum}人`} />
      </Form>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const data = {};
  const { reservedEmailInfo } = state.reservedEmail;
  let formValues = getFormValues('emailRegisterEditForm')(state);
  !formValues && (formValues = reservedEmailInfo);
  if (formValues) {
    data.reservedEmailTitle = formValues.emailTitle || formValues.reservedEmailTitle;
    data.reservedEmailContents = formValues.emailContents || formValues.reservedEmailContents;
    data.reservedEmailReplyTo = formValues.emailReplyTo || formValues.reservedEmailReplyTo;
    data.reservedFlag = formValues.reservedFlag;
    data.reservedDate = formValues.reservedDate;

    data.receiverUserNum = formValues.receiverUserNum || 0;
    if (formValues.emailReceiverList) {
      data.receiverUserNum =
        formValues.emailReceiverList &&
        Object.keys(formValues.emailReceiverList).length;
    }
  }

  return {
    data,
  };
};

export default connect(mapStateToProps)(ReservedEmailInfo);
